import { Button, Table, Input, Space, Select, DatePicker } from "antd";
import SubHeader from "modules/SubComponents/SubHeader";
import moment from "moment";
import { getAllNotifications } from "Network";
import { useEffect, useState } from "react";
import NotificationModal from "./NotificationsModal";
import {
  CloseOutlined,
  EditOutlined,
  EyeOutlined,
  FilterOutlined,
  SearchOutlined,
} from "@ant-design/icons";

const { RangePicker } = DatePicker;

export default function Notifications() {
  const [notificationData, setNotificationData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [mode, setMode] = useState("");
  const [filters, setFilters] = useState({}); // Track active filters
  const [createdAt, setCreatedAt] = useState([]);
  const [scheduleTime, setScheduleTime] = useState([]);
  const [selectedDropdownValue, setSelectedDropdownValue] = useState({}); // Add this line

  useEffect(() => {
    setIsLoading(true);

    if (!filters.createdFrom) setCreatedAt([]);
    if (!filters.scheduleFrom) setScheduleTime([]);

    getAllNotifications(
      filters,
      (success) => {
        setNotificationData(success.data);
        setIsLoading(false);
      },
      (error) => {
        setIsLoading(false);
      }
    );
  }, [filters]);

  // SEARCH FUNCTIONALITY
  const handleColumnSearch = (selectedKeys, confirm, dataIndex) => {
    console.log("🚀 ~ handleColumnSearch ~ selectedKeys:", selectedKeys);
    confirm();

    if (dataIndex === "createdAt") {
      const formattedDates = selectedKeys[0].map((date) =>
        moment(date).format("YYYY-MM-DDT00:00:00.SSS[Z]")
      );
      return setFilters((prev) => ({
        ...prev,
        createdFrom: formattedDates[0],
        createdTo: formattedDates[1],
      }));
    }

    if (dataIndex === "scheduleTime") {
      const formattedDates = selectedKeys[0].map((date) =>
        moment(date).format("YYYY-MM-DDT00:00:00.SSS[Z]")
      );

      return setFilters((prev) => ({
        ...prev,
        scheduleFrom: formattedDates[0],
        scheduleTo: formattedDates[1],
      }));
    }

    if (dataIndex === "Recipients") {
      return setFilters((prev) => ({
        ...prev,
        recipient: selectedKeys[0],
      }));
    }

    if (dataIndex === "status" && selectedDropdownValue?.status) {
      return setFilters((prev) => ({
        ...prev,
        status: selectedDropdownValue?.status,
      }));
    }

    setFilters((prev) => ({
      ...prev,
      [dataIndex]: selectedKeys[0] || undefined,
    }));
  };

  // RESET SEARCH
  const handleResetSearch = (clearFilters, confirm, dataIndex) => {
    clearFilters();
    confirm();
    setFilters((prev) => {
      const newFilters = { ...prev };
      if (dataIndex === "createdAt") {
        delete newFilters?.createdFrom;
        delete newFilters?.createdTo;
        return newFilters;
      }

      if (dataIndex === "scheduleTime") {
        delete newFilters?.scheduleFrom;
        delete newFilters?.scheduleTo;
        return newFilters;
      }

      if (dataIndex === "Recipients") {
        delete newFilters?.recipient;
        return newFilters;
      }

      // if (dataIndex === "status" || dataIndex === "Recipients") {
      //   selectedDropdownValue({});
      // }
      delete newFilters[dataIndex];
      return newFilters;
    });

    if (dataIndex === "Recipients") {
      setSelectedDropdownValue((pre) => {
        const newValue = { ...pre };
        delete newValue?.Recipients;
        return newValue;
      });
    }

    if (dataIndex === "status") {
      setSelectedDropdownValue((pre) => {
        const newValue = { ...pre };
        delete newValue?.status;
        return newValue;
      });
    }
  };

  // SEARCH FIELDS
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleColumnSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            className="d-flex align-items-center"
            type="primary"
            onClick={() => handleColumnSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleResetSearch(clearFilters, confirm, dataIndex)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    filteredValue: filters[dataIndex] ? [filters[dataIndex]] : null,
  });

  // DROPDOWN
  const getDropDownSearch = (dataIndex, options = ["All", "Set"]) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Select
          style={{ width: 188, marginBottom: 8, display: "block" }}
          // value={selectedKeys[0]}
          value={selectedDropdownValue[dataIndex] || selectedKeys[0]}
          onChange={(value) => {
            setSelectedKeys(value ? [value] : []);
            setSelectedDropdownValue((prev) => ({
              ...prev,
              [dataIndex]: value,
            })); // Add this line
          }}
          placeholder={`Select ${dataIndex}`}
          mode={dataIndex === "status" && "multiple"}
        >
          {options.map((option) => (
            <Select.Option
              key={option?.label || option}
              value={option?.value || option}
            >
              {option?.label || option}
            </Select.Option>
          ))}
        </Select>
        <Space>
          <Button
            className="d-flex align-items-center"
            type="primary"
            onClick={() => handleColumnSearch(selectedKeys, confirm, dataIndex)}
            icon={<FilterOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Filter
          </Button>
          <Button
            onClick={() => handleResetSearch(clearFilters, confirm, dataIndex)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <FilterOutlined
        style={{
          color:
            (selectedDropdownValue.Recipients && dataIndex === "Recipients") ||
            // (selectedDropdownValue.Recipients && dataIndex === "Recipients") ||
            filtered
              ? "#1890ff"
              : undefined,
        }}
      />
    ),
    filteredValue: filters[dataIndex] ? [filters[dataIndex]] : null,
  });

  // RANGE PICKER CHANGES
  const handleDateRangeChange = (dates, dateStrings, dataIndex) => {
    if (dates) {
      if (dataIndex === "createdAt") {
        setCreatedAt(dates);
      } else if (dataIndex === "scheduleTime") {
        setScheduleTime(dates);
      }
    }
  };

  // RANGE PICKER
  const getDateRangeSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <RangePicker
          value={dataIndex === "createdAt" ? createdAt : scheduleTime}
          // value={selectedKeys[0]}
          onChange={(dates, dateStrings) => {
            setSelectedKeys(dates ? [dates] : []);
            handleDateRangeChange(dates, dateStrings, dataIndex);
          }}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            className="d-flex align-items-center"
            type="primary"
            onClick={() => handleColumnSearch(selectedKeys, confirm, dataIndex)}
            icon={<FilterOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Filter
          </Button>
          <Button
            onClick={() => handleResetSearch(clearFilters, confirm, dataIndex)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => {
      return (
        <FilterOutlined
          style={{
            color:
              filtered ||
              (createdAt.length > 0 && dataIndex === "createdAt") ||
              (scheduleTime.length > 0 && dataIndex === "scheduleTime")
                ? "#1890ff"
                : undefined,
          }}
        />
      );
    },
    filteredValue: filters[dataIndex] ? [filters[dataIndex]] : null,
  });

  const columns = [
    {
      title: "Title".toUpperCase(),
      dataIndex: "titleEn",
      ...getColumnSearchProps("title"),
    },
    {
      title: "Message".toUpperCase(),
      dataIndex: "messageEn",
      render: (message) => (
        <div className="notifications_message">{message}</div>
      ),
    },
    {
      title: "Recipients".toUpperCase(),
      dataIndex: "Recipients",
      ...getDropDownSearch("Recipients", [
        { value: 1, label: "All Users" },
        { value: 2, label: "Subscribed Users" },
        { value: 3, label: "Unsubscribed Users" },
      ]),
      render: (Recipients) => {
        return (
          <div>
            {Recipients === 1
              ? "All user"
              : Recipients === 2
              ? "Subscribed users"
              : Recipients === 3
              ? "Unsubscribed users"
              : ""}
          </div>
        );
      },
    },
    {
      title: "Admin".toUpperCase(),
      dataIndex: "addedBy",
      ...getColumnSearchProps("adminName"),
    },
    {
      title: "Status".toUpperCase(),
      dataIndex: "status",
      ...getDropDownSearch("status", ["scheduled", "sent", "cancelled"]),
    },
    {
      title: "Created At".toUpperCase(),
      dataIndex: "createdAt",
      ...getDateRangeSearchProps("createdAt"),
      // render: (text) => moment(text).format("DD-MM-YYYY"),
      render: (text) => moment(text).format("DD-MM-YYYY hh:mm A"),
      // render: (text) => text.slice(12),
    },
    {
      title: "Scheduled date and time".toUpperCase(),
      dataIndex: "scheduleTime",
      ...getDateRangeSearchProps("scheduleTime"),
      render: (text) =>
        text ? moment.utc(text).format("DD-MM-YYYY hh:mm A") : "N/A",
    },
    {
      title: "Actions".toUpperCase(),
      key: "action",
      fixed: "right",
      render: (_, record) => {
        const isFutureSchedule =
          record.scheduleTime &&
          moment.utc(record.scheduleTime).isAfter(moment.utc());
        return (
          <Space>
            <Button
              style={{ border: "none", background: "transparent" }}
              onClick={() => {
                setSelectedNotification(record);
                setMode("View");
                setOpen(true);
              }}
            >
              <EyeOutlined style={{ color: " #1890ff" }} />
            </Button>
            {record.status === "scheduled" && (
              <>
                <Button
                  disabled={!isFutureSchedule}
                  className="notifications__edit-btn"
                  style={{ border: "none", background: "transparent" }}
                  onClick={() => {
                    setSelectedNotification(record);
                    setMode("Edit");
                    setOpen(true);
                  }}
                >
                  <EditOutlined
                    style={{ color: !isFutureSchedule ? "gray" : "#1890ff" }}
                  />
                </Button>
                <Button
                  style={{ border: "none", background: "transparent" }}
                  onClick={() => {
                    setSelectedNotification(record);
                    setMode("Cancel");
                    setOpen(true);
                  }}
                >
                  <CloseOutlined style={{ color: "#ff4d4f" }} />
                </Button>
              </>
            )}
          </Space>
        );
      },
    },
  ];

  const handleSendNotification = () => {
    setMode("Send");
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
    setMode("");
    setSelectedNotification(null);
  };

  return (
    <section className="notifications">
      <div className="header__title">Notifications</div>
      <SubHeader bgColor="#356ab3" title="Notifications Data" />
      <Button
        className="notifications__btn"
        type="default"
        onClick={handleSendNotification}
      >
        Send Notification
      </Button>
      <div className="table-container">
        <Table
          dataSource={notificationData}
          columns={columns}
          loading={isLoading}
          scroll={{ x: "max-content" }}
          rowClassName={(record, index) =>
            index % 2 === 0 && "background-even-records "
          }
        />
      </div>
      <NotificationModal
        open={open}
        handleCancel={handleCancel}
        selectedNotification={selectedNotification}
        mode={mode}
        setFilters={setFilters}
      />
    </section>
  );
}
